var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _rect331, _rect332, _rect333, _rect334, _rect335, _rect336, _rect337, _rect338, _rect339, _rect340, _rect341, _rect342, _rect343, _rect344, _rect345, _rect346, _rect347, _rect348, _rect349, _rect350, _rect351, _rect352, _rect353, _rect354, _rect355, _rect356, _rect357, _rect358, _rect359, _rect360, _rect361, _rect362, _rect363, _rect364, _rect365, _rect366, _rect367, _rect368, _rect369, _rect370, _rect371, _rect372, _rect373, _rect374, _rect375, _rect376, _rect377, _rect378, _rect379, _rect380, _rect381, _rect382, _rect383, _rect384, _rect385, _rect386, _rect387, _rect388, _rect389, _rect390, _rect391, _rect392, _rect393, _rect394, _rect395, _rect396, _rect397, _rect398, _rect399, _rect400, _rect401, _rect402, _rect403, _rect404, _rect405, _rect406, _rect407, _rect408, _rect409, _rect410, _rect411, _rect412, _rect413, _rect414, _rect415, _rect416, _rect417, _rect418, _rect419, _rect420, _rect421, _rect422, _rect423, _rect424, _rect425, _rect426, _rect427, _rect428, _rect429, _rect430, _rect431, _rect432, _rect433, _rect434, _rect435, _rect436, _rect437, _rect438, _rect439, _rect440, _rect441, _rect442, _rect443, _rect444, _rect445, _rect446, _rect447, _rect448, _rect449, _rect450, _rect451, _rect452, _rect453, _rect454, _rect455, _rect456, _rect457, _rect458, _rect459, _rect460, _rect461, _rect462, _rect463, _rect464, _rect465, _rect466, _rect467, _rect468, _rect469, _rect470, _rect471, _rect472, _rect473, _rect474, _rect475, _rect476, _rect477, _rect478, _rect479, _rect480, _rect481, _rect482, _rect483, _rect484, _rect485, _rect486, _rect487, _rect488, _rect489, _rect490, _rect491, _rect492, _rect493, _rect494, _rect495, _rect496, _rect497, _rect498, _rect499, _rect500, _rect501, _rect502, _rect503, _rect504, _rect505, _rect506, _rect507, _rect508, _rect509, _rect510, _rect511, _rect512, _rect513, _rect514, _rect515, _rect516, _rect517, _rect518, _rect519, _rect520, _rect521, _rect522, _rect523, _rect524, _rect525, _rect526, _rect527, _rect528, _rect529, _rect530, _rect531, _rect532, _rect533, _rect534, _rect535, _rect536, _rect537, _rect538, _rect539, _rect540, _rect541, _rect542, _rect543, _rect544, _rect545, _rect546, _rect547, _rect548, _rect549, _rect550, _rect551, _rect552, _rect553, _rect554, _rect555, _rect556, _rect557, _rect558, _rect559, _rect560, _rect561, _rect562, _rect563, _rect564, _rect565, _rect566, _rect567, _rect568, _rect569, _rect570, _rect571, _rect572, _rect573, _rect574, _rect575, _rect576, _rect577, _rect578, _rect579, _rect580, _rect581, _rect582, _rect583, _rect584, _rect585, _rect586, _rect587, _rect588, _rect589, _rect590, _rect591, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 136,
    viewBox: "0 0 355 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 354.031,
    height: 135.336,
    fill: "#F1EEF9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 8.42969,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 15.3267,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 72.7988,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 86.5918,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 100.385,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 79.6953,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 93.4883,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 107.282,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect331 || (_rect331 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect332 || (_rect332 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect333 || (_rect333 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect334 || (_rect334 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect335 || (_rect335 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect336 || (_rect336 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect337 || (_rect337 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect338 || (_rect338 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect339 || (_rect339 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect340 || (_rect340 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect341 || (_rect341 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect342 || (_rect342 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect343 || (_rect343 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect344 || (_rect344 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect345 || (_rect345 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect346 || (_rect346 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect347 || (_rect347 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect348 || (_rect348 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect349 || (_rect349 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect350 || (_rect350 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect351 || (_rect351 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect352 || (_rect352 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect353 || (_rect353 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect354 || (_rect354 = /*#__PURE__*/React.createElement("rect", {
    x: 10.7344,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect355 || (_rect355 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4453,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect356 || (_rect356 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect357 || (_rect357 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect358 || (_rect358 = /*#__PURE__*/React.createElement("rect", {
    x: 145.594,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect359 || (_rect359 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect360 || (_rect360 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect361 || (_rect361 = /*#__PURE__*/React.createElement("rect", {
    x: 246.746,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect362 || (_rect362 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect363 || (_rect363 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect364 || (_rect364 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect365 || (_rect365 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect366 || (_rect366 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect367 || (_rect367 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect368 || (_rect368 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect369 || (_rect369 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect370 || (_rect370 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect371 || (_rect371 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect372 || (_rect372 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect373 || (_rect373 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect374 || (_rect374 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect375 || (_rect375 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect376 || (_rect376 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect377 || (_rect377 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect378 || (_rect378 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect379 || (_rect379 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect380 || (_rect380 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect381 || (_rect381 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect382 || (_rect382 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect383 || (_rect383 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect384 || (_rect384 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect385 || (_rect385 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect386 || (_rect386 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect387 || (_rect387 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect388 || (_rect388 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect389 || (_rect389 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect390 || (_rect390 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect391 || (_rect391 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect392 || (_rect392 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect393 || (_rect393 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect394 || (_rect394 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect395 || (_rect395 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect396 || (_rect396 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect397 || (_rect397 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect398 || (_rect398 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect399 || (_rect399 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect400 || (_rect400 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect401 || (_rect401 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect402 || (_rect402 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect403 || (_rect403 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect404 || (_rect404 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect405 || (_rect405 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect406 || (_rect406 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect407 || (_rect407 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect408 || (_rect408 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect409 || (_rect409 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect410 || (_rect410 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect411 || (_rect411 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect412 || (_rect412 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect413 || (_rect413 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect414 || (_rect414 = /*#__PURE__*/React.createElement("rect", {
    x: 19.1602,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect415 || (_rect415 = /*#__PURE__*/React.createElement("rect", {
    x: 52.875,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect416 || (_rect416 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect417 || (_rect417 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect418 || (_rect418 = /*#__PURE__*/React.createElement("rect", {
    x: 154.031,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect419 || (_rect419 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect420 || (_rect420 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect421 || (_rect421 = /*#__PURE__*/React.createElement("rect", {
    x: 255.18,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect422 || (_rect422 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect423 || (_rect423 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect424 || (_rect424 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect425 || (_rect425 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect426 || (_rect426 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect427 || (_rect427 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect428 || (_rect428 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect429 || (_rect429 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect430 || (_rect430 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect431 || (_rect431 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect432 || (_rect432 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect433 || (_rect433 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect434 || (_rect434 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect435 || (_rect435 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect436 || (_rect436 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect437 || (_rect437 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect438 || (_rect438 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect439 || (_rect439 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect440 || (_rect440 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect441 || (_rect441 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect442 || (_rect442 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect443 || (_rect443 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect444 || (_rect444 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect445 || (_rect445 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect446 || (_rect446 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect447 || (_rect447 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect448 || (_rect448 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect449 || (_rect449 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect450 || (_rect450 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect451 || (_rect451 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect452 || (_rect452 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect453 || (_rect453 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect454 || (_rect454 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect455 || (_rect455 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect456 || (_rect456 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect457 || (_rect457 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect458 || (_rect458 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect459 || (_rect459 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect460 || (_rect460 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect461 || (_rect461 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect462 || (_rect462 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect463 || (_rect463 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect464 || (_rect464 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect465 || (_rect465 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect466 || (_rect466 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect467 || (_rect467 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect468 || (_rect468 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect469 || (_rect469 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect470 || (_rect470 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect471 || (_rect471 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect472 || (_rect472 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect473 || (_rect473 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect474 || (_rect474 = /*#__PURE__*/React.createElement("rect", {
    x: 27.5898,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect475 || (_rect475 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect476 || (_rect476 = /*#__PURE__*/React.createElement("rect", {
    x: 95.0195,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect477 || (_rect477 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect478 || (_rect478 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect479 || (_rect479 = /*#__PURE__*/React.createElement("rect", {
    x: 196.176,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect480 || (_rect480 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect481 || (_rect481 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect482 || (_rect482 = /*#__PURE__*/React.createElement("rect", {
    x: 297.32,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect483 || (_rect483 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect484 || (_rect484 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect485 || (_rect485 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect486 || (_rect486 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect487 || (_rect487 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect488 || (_rect488 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect489 || (_rect489 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect490 || (_rect490 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect491 || (_rect491 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect492 || (_rect492 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect493 || (_rect493 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 26.0542,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect494 || (_rect494 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect495 || (_rect495 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect496 || (_rect496 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect497 || (_rect497 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect498 || (_rect498 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect499 || (_rect499 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect500 || (_rect500 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect501 || (_rect501 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect502 || (_rect502 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect503 || (_rect503 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 39.8477,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect504 || (_rect504 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect505 || (_rect505 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect506 || (_rect506 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect507 || (_rect507 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect508 || (_rect508 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect509 || (_rect509 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect510 || (_rect510 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect511 || (_rect511 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect512 || (_rect512 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect513 || (_rect513 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 53.6411,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect514 || (_rect514 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect515 || (_rect515 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect516 || (_rect516 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect517 || (_rect517 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect518 || (_rect518 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect519 || (_rect519 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect520 || (_rect520 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect521 || (_rect521 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect522 || (_rect522 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect523 || (_rect523 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 32.9512,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect524 || (_rect524 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect525 || (_rect525 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect526 || (_rect526 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect527 || (_rect527 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect528 || (_rect528 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect529 || (_rect529 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect530 || (_rect530 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect531 || (_rect531 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect532 || (_rect532 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect533 || (_rect533 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 46.7446,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect534 || (_rect534 = /*#__PURE__*/React.createElement("rect", {
    x: 36.0195,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect535 || (_rect535 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect536 || (_rect536 = /*#__PURE__*/React.createElement("rect", {
    x: 103.449,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect537 || (_rect537 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect538 || (_rect538 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect539 || (_rect539 = /*#__PURE__*/React.createElement("rect", {
    x: 204.605,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect540 || (_rect540 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect541 || (_rect541 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect542 || (_rect542 = /*#__PURE__*/React.createElement("rect", {
    x: 305.754,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect543 || (_rect543 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 60.5381,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect544 || (_rect544 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect545 || (_rect545 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect546 || (_rect546 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect547 || (_rect547 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect548 || (_rect548 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect549 || (_rect549 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect550 || (_rect550 = /*#__PURE__*/React.createElement("rect", {
    x: 61.3008,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect551 || (_rect551 = /*#__PURE__*/React.createElement("rect", {
    x: 111.875,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect552 || (_rect552 = /*#__PURE__*/React.createElement("rect", {
    x: 162.457,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect553 || (_rect553 = /*#__PURE__*/React.createElement("rect", {
    x: 213.031,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect554 || (_rect554 = /*#__PURE__*/React.createElement("rect", {
    x: 263.609,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect555 || (_rect555 = /*#__PURE__*/React.createElement("rect", {
    x: 314.184,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect556 || (_rect556 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect557 || (_rect557 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect558 || (_rect558 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect559 || (_rect559 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect560 || (_rect560 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect561 || (_rect561 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect562 || (_rect562 = /*#__PURE__*/React.createElement("rect", {
    x: 69.7383,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect563 || (_rect563 = /*#__PURE__*/React.createElement("rect", {
    x: 120.305,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect564 || (_rect564 = /*#__PURE__*/React.createElement("rect", {
    x: 170.887,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect565 || (_rect565 = /*#__PURE__*/React.createElement("rect", {
    x: 221.461,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect566 || (_rect566 = /*#__PURE__*/React.createElement("rect", {
    x: 272.035,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect567 || (_rect567 = /*#__PURE__*/React.createElement("rect", {
    x: 322.617,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect568 || (_rect568 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect569 || (_rect569 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect570 || (_rect570 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect571 || (_rect571 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect572 || (_rect572 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect573 || (_rect573 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect574 || (_rect574 = /*#__PURE__*/React.createElement("rect", {
    x: 78.1641,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect575 || (_rect575 = /*#__PURE__*/React.createElement("rect", {
    x: 128.738,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect576 || (_rect576 = /*#__PURE__*/React.createElement("rect", {
    x: 179.312,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect577 || (_rect577 = /*#__PURE__*/React.createElement("rect", {
    x: 229.891,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect578 || (_rect578 = /*#__PURE__*/React.createElement("rect", {
    x: 280.465,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect579 || (_rect579 = /*#__PURE__*/React.createElement("rect", {
    x: 331.047,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect580 || (_rect580 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect581 || (_rect581 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect582 || (_rect582 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect583 || (_rect583 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect584 || (_rect584 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect585 || (_rect585 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 118.011,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect586 || (_rect586 = /*#__PURE__*/React.createElement("rect", {
    x: 86.5938,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect587 || (_rect587 = /*#__PURE__*/React.createElement("rect", {
    x: 137.168,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect588 || (_rect588 = /*#__PURE__*/React.createElement("rect", {
    x: 187.742,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect589 || (_rect589 = /*#__PURE__*/React.createElement("rect", {
    x: 238.316,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect590 || (_rect590 = /*#__PURE__*/React.createElement("rect", {
    x: 288.891,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _rect591 || (_rect591 = /*#__PURE__*/React.createElement("rect", {
    x: 339.473,
    y: 124.908,
    width: 3.0652,
    height: 3.0652,
    fill: "#624822"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.36328 4.59814H345.984",
    stroke: "#624822"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36328 114.179H345.984",
    stroke: "#624822"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.89453 68.2012H347.515",
    stroke: "#624822",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36328 22.2231H345.984",
    stroke: "#624822"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.36328 131.804H345.984",
    stroke: "#624822"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadboard);
export default __webpack_public_path__ + "static/media/breadboard.417bba44f40cf726f4ecf78d6a152bea.svg";
export { ForwardRef as ReactComponent };